const colors = {
  primary: '#00859B',
  primaryDark: '#007A92',
  secondary: '#dbe442',
  rioGrande: '#c3cd1d',
  dudeNavy: '#00263a',
  arcaneNavy: '#003b5c',
  arcticBlue: '#c7ebff',
  tealPastel: '#cffaff',
  columbiaBlue: '#99daff',
  bluePastel: '#e7f6ff',
  white: '#fff',
  black: '#000',
  sterlingGrey: '#e1e1e1',
  chromiumGray: '#c1c6c8',
  silverGray: '#A2AAAD',
  steelGray: '#d0d3d4',
  pewterGray: '#5b6770',
  pinotRed: '#e03c31',
  warning: '#ed6c02',
};
export default colors;
